export default __webpack_public_path__ + "static/media/hinge5.254d7b9b.jpg";